import { Globe } from "lucide-react";
import FolderView from "@/components/FolderView";

const FOLDERS = [
  "Political", "Legislative", "Economic", "Social",
  "Technological", "Environmental", "Academic", "Health",
  "Sport", "Energy", "Natural Resources", "CyberSecurity",
  "Social Media", "Defence", "Crime", "War",
];

export default function ThematicMatters() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center">
            <Globe className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-['Barlow_Condensed'] text-3xl font-bold text-app tracking-wide">
              THEMATIC MATTERS
            </h1>
            <p className="text-app">Cross-cutting thematic intelligence & research</p>
          </div>
        </div>
      </div>

      <FolderView subHub="thematic-matters" folders={FOLDERS} icon={Globe} color="purple" />
    </div>
  );
}
